import React, { useEffect, useContext } from 'react';
import { AppSettings } from './../../config/app-settings.js';

function ExtraComingSoon() {
  const context = useContext(AppSettings);

  useEffect(() => {
    context.handleSetAppSidebarNone(true);
    context.handleSetAppHeaderNone(false);
    context.handleSetAppContentClass('p-0');
    context.handleSetAppTopMenu(true);

    return () => {
      context.handleSetAppSidebarNone(false);
      context.handleSetAppHeaderNone(false);
      context.handleSetAppContentClass('');
      context.handleSetAppTopMenu(false);
    };
    // eslint-disable-next-line
  }, []);

  return (
    <div className="coming-soon">
      <div className="coming-soon-header"
        style={{
          minHeight: '100vh', 
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
        <div className="bg-cover"></div>
        <div className="brand d-flex align-items-center flex-column">
          <img src="/favicon-96x96.png" alt="Traffica" className="navbar-icon mx-2" />
          <b>Traffica</b>
        </div>
        <div className="desc">
          This page is still climbing up the mountain.
        </div>
      </div>
    </div>
  );
}

export default ExtraComingSoon;